<template>
<main class="bg-main lesson-quiz">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>
  <section class="container">
    <lessonquestion v-if="practiceData.content.questions && step" :key="$route.params.lesson_id" :questions="practiceData.content.questions" :step="step" @finquiz="finQuiz" @passedquiz="passedQuiz" @scoreresult="scoreResult"></lessonquestion>

    <div class="row pd-lr-20" v-if="fin_quiz">
      <!-- ここを共通に組み込んで、関数は親関数を観に行くようにする -->
      <button class="button button-primary next" v-if="passed_quiz" @click.prevent="nextStep">{{ $t('common.button.next') }}</button>
      <button type="button" class="button undo" :class="(score_result && score_result=='failure') ? 'button-primary' : 'button-default'" @click.prevent="restartQuiz">{{ $t('lesson.question.button.over') }}</button>
      <router-link class="button button-default back" v-if="!passed_quiz" :to="{ name: 'lesson.introduction'}">{{ $t('lesson.exam.button.to_session') }}</router-link>

    </div>
    <div class="row pd-lr-20" v-if="debug">
      <button v-if="debug" class="button disabled  kaihatsu" @click.prevent="nextStep">スキップ（開発用）</button>
    </div>
  </section>
</main>
</template>

<script>
import {appEnv} from './../../config';
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {mapState} from 'vuex'

import LessonQuestion from './LessonQuestion.vue';
import componentContentHead from '../shared/ContentHead.vue';

export default {
  name: 'LessonPractice',
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'lessonquestion': LessonQuestion,
  },
  data(){
    return{
      step: 'practice',
      fin_quiz: false,
      passed_quiz: false,
      score_result: null

    }
  },
  computed: {
    ...mapState({
      user: state => state.auth
    }),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    practiceData() {
      return this.$store.getters.lesson_content.practice ? this.$store.getters.lesson_content.practice : {content: []}
    },
    debug() {
      return (appEnv !== 'production')
    }
  },

  created() {
    if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
    this.$router.push({name: 'lesson.introduction'});
    }
  },
  methods: {
    finQuiz() {
      this.fin_quiz = true
    },
    passedQuiz() {
      this.passed_quiz = true
    },
    scoreResult(result) {
      this.score_result = result
    },
    restartQuiz(){
      let to = '';
      if (this.step == 'practice') {
        to = 'lesson.practice';
      } else if (this.step == 'listening_practice') {
        to = 'lesson.listening.practice';
      } else {
        to = 'lesson.exam';
      }
      this.$router.go({name: to})
    },
    nextStep() {
      if (this.$store.getters.lesson_content[this.step].status != 'completed') {
        this.statusContent('completed', this.step);
        this.$store.dispatch('updateLessonContentStatus', {type: 'practice', status: 'completed' });
      }
      this.learningTempLog();
      this.learningLog();

      this.$router.push({name: 'lesson.review'})
    },
    goBack() {
      this.$router.push({name: 'lesson.grammar'});
    }
  }
}
</script>
<style>
.kaihatsu {
  margin: 20px 0;
}

</style>
